<template>
  <div style="height: 100%; display: flex; flex-flow: column">
    <el-row class="mb-1" :gutter="5">
      <el-col>
        <el-button type="info" plain @click="AddProcess"><i class="iconfont icon-add-new"></i>&nbsp;&nbsp;添加工序&资源
        </el-button>
        <el-button type="info" plain class="ml-2" @click="AddItem"><i
            class="iconfont icon-add-new"></i>&nbsp;&nbsp;添加部件/材料
        </el-button>
        <el-button type="info" plain class="ml-2" @click="AddAccessory"><i
            class="iconfont icon-add-new"></i>&nbsp;&nbsp;添加附件
        </el-button>
        <el-button type="info" plain class="ml-2" @click="CheckProcess">工艺检查 </el-button>
        <el-tag class="ml-2" v-if="copy_row">{{
          `当前复制数据: 工序名称: ${copy_row.ProcessName} ${copy_row.ResourceName ? ', 资源名称:' + copy_row.ResourceName : ''} `
        }}</el-tag>
      </el-col>
    </el-row>
    <div style="flex: 1; height: 100%" ref="tree_table_div">
      <el-table size="mini" :data="tableData" style="width: 100%" row-key="id" border default-expand-all
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" @row-click="RowClick"
        :max-height="maxTableHeight" :row-class-name="tableRowClassName" highlight-current-row class="tree-table-class">
        <el-table-column prop="ProcessName" label="工序名称" sortable width="350">
        </el-table-column>
        <el-table-column prop="ResourceName" label="资源名称" sortable width="100">
        </el-table-column>
        <el-table-column prop="ProcessCount" label="工序次数">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit || !scope.row.ResourceName">{{
              scope.row.ProcessCount
            }}</span>
            <div v-else>
              <el-input-number type="number" placeholder="请输入" v-model.number="scope.row.ProcessCount" :controls="false"
                style="width:100%"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="StandardManpower" label="标准人力">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit || !scope.row.ResourceName">{{
              scope.row.StandardManpower
            }}</span>
            <div v-else>
              <el-input-number type="number" placeholder="请输入" v-model.number="scope.row.StandardManpower"
                :controls="false" style="width:100%"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="StandardWorkingHours" label="标准工时">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit || !scope.row.ResourceName">{{
              scope.row.StandardWorkingHours
            }}</span>
            <div v-else>
              <el-input-number type="number" placeholder="请输入" v-model.number="scope.row.StandardWorkingHours"
                :controls="false" style="width:100%"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Kilowatt" label="功率">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit || !scope.row.ResourceName">{{
              scope.row.Kilowatt
            }}</span>
            <div v-else>
              <el-input-number type="number" placeholder="请输入" v-model.number="scope.row.Kilowatt" :controls="false"
                style="width:100%"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="TimeSetting" label="设置时间">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit || !scope.row.ResourceName">{{
              scope.row.TimeSetting
            }}</span>
            <div v-else>
              <el-input-number type="number" placeholder="请输入" v-model.number="scope.row.TimeSetting" :controls="false"
                style="width:100%"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="ProductionCapacity" label="产能">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit || !scope.row.ResourceName">{{
              scope.row.ProductionCapacity
            }}</span>
            <div v-else>
              <el-input-number type="number" placeholder="请输入" v-model.number="scope.row.ProductionCapacity"
                :controls="false" style="width:100%"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="GoodProductRate" label="良率">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit || !scope.row.ResourceName">{{
              scope.row.GoodProductRate
            }}</span>
            <div v-else>
              <el-input-number type="number" placeholder="请输入" v-model.number="scope.row.GoodProductRate"
                :controls="false" style="width:100%"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="MouldCount" label="模数">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit || !scope.row.ResourceName">{{
              scope.row.MouldCount
            }}</span>
            <div v-else>
              <el-input-number type="number" placeholder="请输入" v-model.number="scope.row.MouldCount" :controls="false"
                style="width:100%"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="RunningParameters" label="变化参数">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit || !scope.row.ResourceName">{{
              scope.row.RunningParameters
            }}</span>
            <div v-else>
              <el-input-number type="number" placeholder="请输入" v-model.number="scope.row.RunningParameters"
                :controls="false" style="width:100%"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="SortNo" label="排序">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit || !scope.row.ResourceName">{{
              scope.row.SortNo
            }}</span>
            <div v-else>
              <el-input-number type="number" placeholder="请输入" v-model.number="scope.row.SortNo" :controls="false"
                style="width:100%"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Description" label="备注" width="200">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit">{{
              scope.row.Description
            }}</span>
            <div v-else>
              <el-input type="text" placeholder="请输入内容" v-model="scope.row.Description" maxlength="500"
                show-word-limit></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope" v-if="scope.row.ResourceName || scope.row.id != 0">
            <el-button type="text" size="small" @click="changeRowState(scope.row)" :disabled="scope.row.isDisabled">{{
              scope.row.isEdit ? '保存' : '编辑'
            }}</el-button>
            <el-button type="text" size="small" @click="CopyRow(scope.row)">复制</el-button>
            <el-button type="text" size="small" @click="PasteRow(scope.row)">粘贴</el-button>
            <el-button type="text" size="small" @click="DeleteRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <BaseModal :mask="false" ref="ProcessModal" :title="add_process_title" @saveData="SaveData" :width="'40%'">
      <template #modal_content>
        <el-form :rules="rules" :model="ProcessModel" ref="dataForm" label-width="100px" class="demo-dataForm">

          <el-form-item label="工序资源" prop="ProcessResourceId">
            <el-cascader v-model="ProcessModel.ProcessResourceId" :options="ProcessProcessResource_Options" filterable
              style="width: 100%;" @change="SelectProcess"></el-cascader>
          </el-form-item>

          <el-row>
            <el-col :span=12>
              <el-form-item label="工序次数" prop="ProcessCount">
                <el-input style="width: 100%" clearable v-model.number="ProcessModel.ProcessCount"
                  placeholder="请输入工序次数"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span=12>
              <el-form-item label="标准人力" prop="StandardManpower">
                <el-input style="width: 100%" clearable v-model.number="ProcessModel.StandardManpower"
                  placeholder="请输入标准人力"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span=12>
              <el-form-item label="标准工时" prop="StandardWorkingHours">
                <el-input style="width: 100%" clearable v-model.number="ProcessModel.StandardWorkingHours"
                  placeholder="请输入标准工时"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span=12>
              <el-form-item label="功率" prop="Kilowatt">
                <el-input style="width: 100%" clearable v-model.number="ProcessModel.Kilowatt"
                  placeholder="请输入功率"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span=12>
              <el-form-item label="设置时间" prop="TimeSetting">
                <el-input-number style="width: 100%" clearable v-model.number="ProcessModel.TimeSetting"
                  placeholder="请输入设置时间"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span=12>
              <el-form-item label="产能" prop="ProductionCapacity">
                <el-input style="width: 100%" clearable v-model.number="ProcessModel.ProductionCapacity"
                  placeholder="请输入产能"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span=12>
              <el-form-item label="良率" prop="GoodProductRate">
                <el-input style="width: 100%" clearable v-model.number="ProcessModel.GoodProductRate"
                  placeholder="请输入良率"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span=12>
              <el-form-item label="模数" prop="MouldCount">
                <el-input style="width: 100%" clearable v-model.number="ProcessModel.MouldCount"
                  placeholder="请输入模数"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span=12>
              <el-form-item label="变化参数" prop="RunningParameters">
                <el-input-number style="width: 100%" clearable v-model="ProcessModel.RunningParameters" :min="0.001"
                  :step="1" step-strictly placeholder="请输入变化参数"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span=12>
              <el-form-item label="排序" prop="SortNo">
                <el-input-number style="width: 100%" clearable v-model="ProcessModel.SortNo" :min="0" :step="1"
                  step-strictly placeholder="请输入排序"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注" prop="Derscription">
            <el-input type="textarea" clearable v-model="ProcessModel.Description" maxlength="500"
              show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
    <el-drawer :title="item_title" :visible.sync="drawer" :with-header="true" :size="'70%'" @opened="DrawerOpend"
      style="height: calc(100vh)" :modal="false">
      <div style="height: 100%;padding: 1rem;">
        <TempQuotationCreateItem ref="TempQuotationCreateItemRef" :SelectItemData="SelectItemData" :UseBySelect="true"
          :UnSelectData="UnSelectData" @SelectRowToProcess="SelectRowToProcess"
          :currentQuotationDetailId="Quotation_Item_Detail_Id">
        </TempQuotationCreateItem>
      </div>
    </el-drawer>
    <el-dialog :title="dialog_title" :visible.sync="accessoryVisible" width="60%" :top="'5vh'"
      :close-on-click-modal="false" :modal="false" @opened="bottomDialogOpened">
      <FileUpload ref="refAccessory" :accessoryCategory="'TempQuotation'" :showUpload="true"
        @setAccessory="bottomSetAccessory">
      </FileUpload>
    </el-dialog>
  </div>
</template>
<script>
import BaseModal from '../components/modals/baseModal'
import * as TempQuotationCreateProcessController from '../../controllers/sd/TempQuotationCreateProcessController'
import * as TempQuotationCreateItemController from '../../controllers/sd/TempQuotationCreateItemController'
import * as TempQuotationItemController from '../../controllers/sd/TempQuotationItemController'
import * as TempQuotationController from '../../controllers/sd/TempQuotationController'
import TempQuotationItem from './TempQuotationItem.vue'
import TempQuotationCreateItem from './TempQuotationCreateItem'
import FileUpload from '../FileUpload.vue'
export default {
  components: { BaseModal, TempQuotationItem, FileUpload, TempQuotationCreateItem },
  props: {
    SelectItemData: { type: Object, default: null },
  },
  data() {
    return {
      Quotation_Item_Detail_Id: null,
      UnSelectData: [],
      accessoryVisible: false,
      dialog_title: '附件列表',
      maxTableHeight: 250,
      quotation_item_fields: TempQuotationItemController.fields.default,
      drawer: false,
      current_item: null,
      ProcessModel: {
        id: '', //id
        ProcessName: '', //工序名称
        ResourceName: '', //资源名称
        ProcessCount: 0, //工序次数
        StandardManpower: 0,//标准人力
        StandardWorkingHours: 0,//标准工时
        Kilowatt: 0,//功率
        TimeSetting: 0,//设置时间
        ProductionCapacity: 0,//产能
        GoodProductRate: 0,//良率
        MouldCount: 0,//模数
        RunningParameters: 1,//模数
        SortNo: 0,//排序
        Description: '', //备注

      },
      item_title: '添加物料/部件',
      tableData: [],
      fields: [],
      add_process_title: '',
      rules: TempQuotationCreateProcessController.rules,
      date_picker_label: 'common.search',
      query_lable: this.$t('common.query'),
      isBusy: false,
      copy_row: null,
      copy_state: true,
      all_table_data: [],
      ProcessProcessResource_Options: [],
    }
  },
  async created() { },
  async mounted() {
    this.$nextTick(() => {
      this.maxTableHeight =
        this.$refs.tree_table_div.offsetHeight - 50
    })
    //查询数据并构造数据
    await this.QueryDataAndConstruction(this.SelectItemData.id)
    this.GetProcessOptions()
  },
  methods: {
    //工艺检查
    async CheckProcess() {
      let p = { is_deleted: { '=': 0 }, QuotationId: { '=': this.SelectItemData.id } }
      let process_result = await TempQuotationCreateProcessController.methods.getData(p)
      let item_result = await TempQuotationCreateItemController.methods.getData(p)
      if (!_.isNull(process_result) && process_result && process_result.length > 0 && !_.isNull(item_result) && item_result && item_result.length > 0) {
        //数据构造
        process_result = process_result[0]
        item_result = item_result[0]
        //进行对比
        this.CompareItem(item_result, process_result)
      } else {
        this.msgToasts('未查询到工序或物料数据,无法进行对比!', 'error')
      }
    },
    //进行对比,在data2中如果有data1中没有的物料,则弹窗进行提示.匹配成功则提示成功
    CompareItem(item_result, process_result) {
      let p_item = _.filter(process_result, function (o) { return o.ItemId })
      let i_item = _.filter(item_result, function (o) { return o.ItemId })
      let diff = []
      for (var i = 0; i < i_item.length; i++) {
        let _index = _.findIndex(p_item, function (j) {
          return j.ItemId === i_item[i].ItemId
        })
        if (_index < 0) {
          diff.push(i_item[i])
        }
      }
      if (diff.length > 0) {
        this.UnSelectData = diff
        this.item_title = '物料检查',
          this.drawer = true
      }
      else {
        this.msgToasts('工艺检查成功!', 'success')
      }
    },
    //选择物料tree中的数据到工艺树下
    async SelectRowToProcess(row) {
      console.log(row.id)
      let index = _.findIndex(this.all_table_data, function (o) { return o.Quotation_Item_Detail_Id == row.id })
      if (index > -1) {
        this.msgToasts('该数据已添加', 'error')
        return
      }
      //相同的物料或部件 无法进行添加
      let p = {}
      p.ProcessName = `${row.PartName}/${row.ItemTypeName}${row.ItemName ? '/' + row.ItemName : ''}`
      // if(p.ProcessName.length>60)
      // {
      //   this.msgToasts('工序名长度超过限制,最大长度为60', 'error')
      //   return;
      // }
      if (row.ItemId) {
        p.ItemId = row.ItemId
      }
      p.ParentId = this.current_item.id//父id
      p.QuotationId = this.SelectItemData.id//主档id
      p.Quotation_Item_Detail_Id = row.id//物料明细id

      let rt = await TempQuotationCreateProcessController.methods.saveData({
        add: p,
      })
      if (rt) {
        //给table中添加一行数据
        if (this.current_item.children instanceof Array) {
          this.current_item.children.push(rt[0])
          this.all_table_data.push(rt[0])
        } else {
          this.$set(this.current_item, 'children', [rt[0]])
          this.msgToasts('新增成功!', 'success')
        }
      } else {
        this.msgToasts('新增失败!', 'error')
      }
    },
    //获取下拉的option选项
    GetProcessOptions() {
      const _this = this;
      const _data = _.filter(this.$store.state.biz_data.baseData.ProcessResources, function (o) { return o.dataAreaId === _this.SelectItemData.dataAreaId })

      let gp = _.groupBy(_data, 'ProcessName')
      for (let key in gp) {
        let children = []
        for (var i = 0; i < gp[key].length; i++) {
          children.push({ value: gp[key][i].id, label: gp[key][i].ResourceName })
        }
        this.ProcessProcessResource_Options.push({ value: key, label: key, children: children })
      }

    },
    //选择工序下拉
    SelectProcess(val) {
      // console.log(val)
      this.ProcessModel.ResourceName = ''
      this.ProcessModel.ProcessName = ''
      let item = _.find(this.$store.state.biz_data.baseData.ProcessResources, { id: val[1] })
      let _item = _.cloneDeep(item)
      delete _item.id
      this.ProcessModel = Object.assign({}, this.ProcessModel, _item)

      delete this.ProcessModel.AddCount_1To1K
      delete this.ProcessModel.AddCount_1001To2K
      delete this.ProcessModel.AddCount_2001To3K
      delete this.ProcessModel.AddCount_3001To5K
      delete this.ProcessModel.AddCount_5001To10K
      delete this.ProcessModel.AddCount_10001To20K
      delete this.ProcessModel.AddCount_20001To40K
      delete this.ProcessModel.AddCount_40001ToMax
      delete this.ProcessModel.AddRate_1To1K
      delete this.ProcessModel.AddRate_1001To2K
      delete this.ProcessModel.AddRate_2001To3K
      delete this.ProcessModel.AddRate_3001To5K
      delete this.ProcessModel.AddRate_5001To10K
      delete this.ProcessModel.AddRate_10001To20K
      delete this.ProcessModel.AddRate_20001To40K
      delete this.ProcessModel.AddRate_40001ToMax
    },
    //添加附件
    AddAccessory() {
      this.accessoryVisible = true
    },
    //粘贴
    PasteRow(row) {
      const _this = this
      //数据验证
      if (!this.copy_row) {
        return
      }
      //判断是否为末端
      if (row.ItemId) {
        this.msgToasts('该行为末端无法粘贴数据集!', 'warning')
        return
      }
      //判断复制行能否成为被粘贴行的子级,1.复制行为部件/物料时,上一级必须为工艺. 2.复制行为工艺时,上一级必须为部件
      if (!row.ResourceName && !this.copy_row.ResourceName) {
        this.msgToasts('该行不是工艺,无法进行复制!', 'warning')
        return
      }
      if (row.ResourceName && this.copy_row.ResourceName) {
        this.msgToasts('该行不是部件,无法进行复制!', 'warning')
        return
      }
      //粘贴确认
      this.$confirm('是否复制该行数据及其包含的数据集？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          await _this.GetCopyData([this.copy_row], row.id)
          await this.QueryDataAndConstruction(this.SelectItemData.id)
          if (_this.copy_state) {
            _this.msgToasts(this.$t('notify.action_successfully'), 'success')
            _this.copy_state = true
          }
        })
        .catch(() => { })
    },
    //递归获取复制数据
    async GetCopyData(data, id) {
      const _this = this
      for (var i = 0; i < data.length; i++) {
        let p = {}
        let add_data = []
        let _copy = _.cloneDeep(data[i])
        delete _copy.children
        delete _copy.isEdit
        delete _copy.id
        delete _copy.isDisabled
        _copy.ParentId = id
        add_data.push(_copy)
        p.add = add_data
        let rt = await TempQuotationCreateProcessController.methods.saveData(p)
        if (rt) {
          if (data[i].children instanceof Array && data[i].children.length > 0)
            await _this.GetCopyData(
              data[i].children,
              rt[0].id,
            )
        } else {
          _this.copy_state = false
          _this.msgToasts(_this.$t('notify.action_unsuccessfully'), 'error')
        }
      }
    },
    //复制
    CopyRow(row) {
      this.copy_row = row
    },
    //递归获取删除数据
    GetDeleteData(data, arr) {
      for (var i = 0; i < data.length; i++) {
        arr.push(data[i])
        if (data[i].children instanceof Array && data[i].children.length > 0) {
          this.GetDeleteData(data[i].children, arr)
        }
      }
    },
    //删除数据
    DeleteRow(row) {
      const _this = this
      //删除确认
      this.$confirm('是否删除该行数据及其包含的数据集？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let p = {}
          let delete_data = []
          delete_data.push(row)
          if (row.children instanceof Array && row.children.length > 0) {
            _this.GetDeleteData(row.children, delete_data)
          }
          p.delete = delete_data
          let rt = await TempQuotationCreateProcessController.methods.saveData(p)
          if (rt) {
            await this.QueryDataAndConstruction(this.SelectItemData.id)
            this.msgToasts(this.$t('notify.action_successfully'), 'success')
          } else {
            this.msgToasts(this.$t('notify.action_unsuccessfully'), 'error')
          }
        })
        .catch(() => {
          return
        })
    },
    GetEditData(row, edit_data) {
      let p = _.cloneDeep(row)
      delete p.isEdit
      delete p.isCopy
      delete p.children
      delete p.isDisabled
      edit_data.push(p)
      if (row.children instanceof Array && row.children.length > 0) {
        for (var i = 0; i < row.children.length; i++) {
          this.GetEditData(row.children[i], edit_data)
        }
      }
    },
    //修改保存时的数据检查
    CheckEditData(row) {
      if (row.ProcessCount === ''
        || row.ProcessCount < 0
        || row.StandardManpower === ''
        || row.StandardManpower < 0
        || row.StandardWorkingHours === ''
        || row.StandardWorkingHours < 0
        || row.Kilowatt === ''
        || row.Kilowatt < 0
        || row.TimeSetting === ''
        || row.TimeSetting < 0
        || row.ProductionCapacity === ''
        || row.ProductionCapacity < 0
        || row.GoodProductRate === ''
        || row.GoodProductRate < 0
        || row.MouldCount === ''
        || row.MouldCount < 0
        || row.SortNo === '') {
        this.msgToasts('修改失败,请录入正确的数值!', 'error')
        return false
      }
      return true
    },
    //改变修改状态并实际修改数据
    async changeRowState(row) {
      if (row.isEdit) {
        let p = _.cloneDeep(row)
        delete p.isEdit
        delete p.isCopy
        delete p.children
        delete p.isDisabled
        //数据检查
        if (!this.CheckEditData(p)) return
        let chkrt = await TempQuotationCreateProcessController.methods.getData({
          ParentId: { '=': p.ParentId },
          QuotationId: { '=': p.QuotationId },
          SortNo: { '=': p.SortNo },
          id: { '<>': p.id }
        }
        )
        if (!_.isNull(chkrt) && chkrt && chkrt.length > 0 && chkrt[0].length > 0) {
          this.msgToasts('当前排序编号已存在!', 'warning')
          return
        }
        else {
          let rt = await TempQuotationCreateProcessController.methods.saveData({
            edit: p,
          })
          if (rt) {
            this.msgToasts('修改成功', 'success')
            await this.QueryDataAndConstruction(this.SelectItemData.id)
          } else {
            this.msgToasts('修改失败', 'error')
          }
          this.SetDisabled(row, this.tableData, false)
        }
      }
      this.$set(row, 'isEdit', !row.isEdit)
      if (row.isEdit) {
        //将出本行外所有行的 isDisabled 置为true
        this.$set(row, 'isDisabled', false)
        this.SetDisabled(row, this.tableData, row.isEdit)
      }
    },
    SetDisabled(row, data, state) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].id != row.id)
          this.$set(data[i], 'isDisabled', state)
        if (data[i].children instanceof Array && data[i].children.length > 0) {
          this.SetDisabled(row, data[i].children, state)
        }
      }
    },
    //构造第一行数据
    AddFirstLineData() {
      this.tableData = []
      this.tableData.push({
        id: -1,
        ProcessName: this.SelectItemData.tempItemName
          ? this.SelectItemData.tempItemName
          : this.SelectItemData.ItemName,
      })
    },
    //查询并构造树形数据
    async QueryDataAndConstruction(quotationId) {
      this.AddFirstLineData()
      let p = { is_deleted: { '=': 0 }, QuotationId: { '=': quotationId } }
      let _result = await TempQuotationCreateProcessController.methods.getData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        //数据构造
        _result[0].forEach(o => {
          if (o.ParentId == 0) {
            o.ParentId = -1
          }
        });
        _result[0] = _.orderBy(_result[0], ["SortNo"], ["asc"])
        this.all_table_data = _result[0]
        this.all_table_data.push(this.tableData[0])
        this.makeTableData(_result[0], this.tableData)
      }
    },
    //树状数据构造
    makeTableData(all_data, data) {
      data = _.orderBy(data, ["SortNo"], ["asc"])
      for (let i = 0; i < data.length; i++) {
        let children = _.filter(all_data, { ParentId: data[i].id })
        if (children) {
          this.$set(data[i], 'children', children)
          this.makeTableData(all_data, data[i].children)
        }
      }
    },
    // 行点击事件
    RowClick(row, column, event) {
      this.current_item = row
      //获取当前行的parent的quotationitemdetailid
      let parent = _.find(this.all_table_data, function (o) { return o.id === row.ParentId })
      if (parent) {
        this.Quotation_Item_Detail_Id = parent.Quotation_Item_Detail_Id
        if (parent.id == -1)
          this.Quotation_Item_Detail_Id = -1
      }
    },
    //清除model
    clearModel() {
      this.ProcessModel = {
        id: '', //id
        ProcessName: '', //工序名称
        ResourceName: '', //资源名称
        ProcessCount: 0, //工序次数
        StandardManpower: 0,//标准人力
        StandardWorkingHours: 0,//标准工时
        Kilowatt: 0,//功率
        TimeSetting: 0,//设置时间
        ProductionCapacity: 0,//产能
        GoodProductRate: 0,//良率
        MouldCount: 0,//模数
        RunningParameters: 1,//变化参数
        SortNo: 0,//模数
        Description: '', //备注
      }
    },
    //添加物料
    AddItem() {
      //检查
      if (!this.current_item) {
        this.msgToasts('请先选择要添加的数据行!', 'warning')
        return
      }
      //上一级不为工序时无法添加
      if (
        !this.current_item.ResourceName &&
        !this.current_item.ProcessResourceId
      ) {
        this.msgToasts('该行无法继续添加下一级!', 'warning')
        return
      }
      this.UnSelectData = []
      this.item_title = '添加物料/部件'
      this.drawer = true
    },
    //添加部件
    AddProcess() {
      //检查
      if (!this.current_item) {
        this.msgToasts('请先选择要添加的数据行!', 'warning')
        return
      }
      //1.工艺下不能添加工艺
      //2.物料下不能添加工艺
      if (
        this.current_item.ResourceName
      ) {
        this.msgToasts('该行无法继续添加下一级!', 'warning')
        return
      }
      if (this.current_item.ItemId) {
        this.msgToasts('该行无法继续添加下一级!', 'warning')
        return
      }
      this.clearModel()
      this.add_process_title = `添加工序&资源`
      this.$refs.ProcessModal.show()
    },
    //部件保存
    async AddProcessData(cb) {
      let p = {}
      p = _.cloneDeep(this.ProcessModel)
      console.log(this.current_item)
      p.ParentId = this.current_item.id//父id
      p.QuotationId = this.SelectItemData.id//主档id
      p.ProcessResourceId = p.ProcessResourceId[1]
      //先检查是否排序存在

      let chkrt = await TempQuotationCreateProcessController.methods.getData({
        ParentId: { '=': p.ParentId },
        QuotationId: { '=': p.QuotationId },
        SortNo: { '=': p.SortNo }
      })
      if (!_.isNull(chkrt) && chkrt && chkrt.length > 0 && chkrt[0].length > 0) {
        cb(true, false, '当前排序编号已存在')
        return
      }
      else {
        delete p.dataAreaId
        let rt = await TempQuotationCreateProcessController.methods.saveData({
          add: p,
        })
        if (rt) {
          await this.QueryDataAndConstruction(this.SelectItemData.id)
          cb(true, true)
        } else {
          cb(false)
        }
      }
    },
    //给树形table添加数据
    insertTableData(list, data) {
      let res = list.find((item) => item.id === data.ParentId)
      if (res) {
        if (res.children instanceof Array) {
          res.children.push(data)
        } else {
          this.$set(res, 'children', [data])
        }
        return
      } else {
        for (let i = 0; i < list.length; i++) {
          if (list[i].children instanceof Array) {
            this.insertTableData(list[i].children, data)
          }
        }
      }
    },
    async SaveData(cb) {
      this.$refs.dataForm.validate(async (valid) => {
        if (valid) {
          //新增或保存过程
          if (this.ProcessModel.id === '') await this.AddProcessData(cb)
        } else {
          cb(true, false, '')
          return
        }
      })
    },
    async DrawerOpend() {
      //
    },
    //附件open
    bottomDialogOpened() {
      let _accessory = this.SelectItemData.Accessory
      this.$refs.refAccessory.getAccessory(_accessory, this.SelectItemData.id)
    },
    async bottomSetAccessory(data) {
      this.SelectItemData.Accessory = data
      await this.dialogClosed()
    },
    async dialogClosed() {
      if (this.SelectItemData && this.SelectItemData.Accessory) {
        let m = {
          id: this.SelectItemData.id,
          Accessory: this.SelectItemData.Accessory,
        },
          ml = []
        if (m.id && m.id != '') ml.push(m)
        this.SelectItemData.AccessoryCount = JSON.parse(
          this.SelectItemData.Accessory
        ).length
        await TempQuotationController.methods.updateAccessory({ edit: ml })
      }
    },
    //行样式修改
    tableRowClassName({ row }) {
      if (row.ResourceName) {
        return 'process-row'
      } else return ''
    },
  },
}
</script>
<style>
.hb_table_quotationorder_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 195rem;
}

.el-table .process-row {
  background: #FDE2E2;
}

.tree-table-class .el-table__row {
  height: 30px;
  padding: 0;
}

.tree-table-class .el-table__cell {
  white-space: normal;
  padding: 0;
}
</style>
